var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 4.98879C16.5007 4.98879 18.334 4.0689 19.4716 5.00026C19.6567 5.15001 19.8879 5.44644 19.9894 5.66435C20.1673 6.04643 20.1673 6.41693 20.1673 7.15794V17.2495C20.1673 18.1721 19.214 18.8058 18.334 18.5998C17.4909 18.4024 16.5611 18.2931 15.584 18.2931C13.8266 18.2931 12.2221 18.6468 11.0007 19.2299C9.77919 19.8129 8.17463 20.1668 6.41732 20.1668C5.44022 20.1668 4.51037 20.0574 3.66732 19.86C3.12538 19.7332 2.85441 19.6697 2.52972 19.4072C2.34453 19.2574 2.11341 18.961 2.01193 18.7431C1.83398 18.361 1.83398 17.9905 1.83398 17.2495V7.15794C1.83398 6.23533 2.78735 5.60165 3.66732 5.80764C4.37749 5.97387 5.14927 6.07769 5.95898 6.10628",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2923 12.375C13.2923 13.6406 12.2663 14.6667 11.0007 14.6667C9.73501 14.6667 8.70898 13.6406 8.70898 12.375C8.70898 11.1094 9.73501 10.0833 11.0007 10.0833C12.2663 10.0833 13.2923 11.1094 13.2923 12.375Z",
    stroke: "#4A5564",
    strokeWidth: 1.76
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04102 13.2917V13.3007",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.959 11.4512V11.4602",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70898 5.04166C9.15955 5.50522 10.3588 7.33333 11.0007 7.33333M11.0007 7.33333C11.6425 7.33333 12.8418 5.50522 13.2923 5.04166M11.0007 7.33333V1.83333",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredit);
export default __webpack_public_path__ + "static/media/Icon-credit.aa7515b3.svg";
export { ForwardRef as ReactComponent };